export enum ContactNotificationType {
  AllNotifications = 1,
  OnlyWinnerFinalistNotification = 2,
}

export const contactNotificationTypeToDisplayName: Record<ContactNotificationType, string> = {
  [ContactNotificationType.AllNotifications]: 'All notifications',
  [ContactNotificationType.OnlyWinnerFinalistNotification]: 'Only winner/finalist notification',
}
